module.exports = __webpack_public_path__ + "static/img/banner_f002.2ee992c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner_f002.jpg
// module id = Ila0
// module chunks = 40